import { DownOutlined, SearchOutlined } from '@ant-design/icons'
import { ConfigProvider, Pagination, Select, TreeSelect } from 'antd'
import React from 'react'
import '../../CampaignSendsNotifications.scss'

import viVN from 'antd/locale/vi_VN'
import '../../../../../components/ExportImgFigma'

import { ColDef } from 'ag-grid-community'
import { AgGridReact } from 'ag-grid-react'
import { NodataTable } from '../../../../../components/NoDataTable'
import { formatNumber } from '../../../../../services/mixin'
import { CustomLoadingOverlayTable, dataPagination, formatPrice } from '../../../../../until'
import { IPagination } from '../../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup'
import { ISelectedCustomer } from '../../../../Customers/CustomerGroup/Component/EditGroup/EditGroup'
import '../../CampaignSendsNotifications.scss'
import { IDataFilterGroupList, useCustomerGroupContext } from '../../Create'

interface props {
    loading: boolean
    memoizedColumnDefs: ColDef<any, any>[]
    listMatchedCustomers: any[]
    dataFilterMatchedCustomers: IDataFilterGroupList
    paginationMatchedCustomers: IPagination
    selectedIdCustomer: ISelectedCustomer[]

    setDataFilterMatchedCustomers: (value: IDataFilterGroupList) => void
    onPaginationMatchedCustomers: (page: number, pageSize: number) => void

}

const TableCustomerDetail: React.FC<props> = ({
    loading,
    memoizedColumnDefs,
    dataFilterMatchedCustomers, paginationMatchedCustomers,
    listMatchedCustomers,
    selectedIdCustomer,
    setDataFilterMatchedCustomers, onPaginationMatchedCustomers,
}) => {


    const { sLCategoryCar, sLNationwide } = useCustomerGroupContext()
    const isVoucherCustomerList = selectedIdCustomer.some(item => item.addType === 1);

    return (
        <div className="custom-page-css  w-full flex flex-col  gap-3">
            <span className="custom-page-css flex-2 text-344054 font-bold text-base">Danh sách khách hàng</span>
            <div className="custom-page-css flex items-start gap-2">
                <div className="custom-page-css h-fit flex-1 d-flex  gap-2 overflow-hidden">
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3 py-2-px justify-between overflow-hidden">
                        <div className="d-flex align-center w-full">
                            <TreeSelect
                                className={'w-full text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none'}
                                multiple
                                showSearch
                                placeholder="Chọn đơn vị"
                                allowClear
                                value={dataFilterMatchedCustomers?.listUnit}
                                treeDefaultExpandAll={false}
                                treeData={sLNationwide}
                                filterTreeNode={(input: string, option: any) =>
                                    typeof option?.label === 'string' && option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={(e) => setDataFilterMatchedCustomers({ ...dataFilterMatchedCustomers, listUnit: e })}
                            />
                        </div>
                    </div>
                </div>

                <div className="custom-page-css h-fit flex-1 d-flex gap-2 overflow-hidden">
                    <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3 py-2-px justify-between overflow-hidden">
                        <div className="d-flex align-center w-full">
                            <Select
                                showSearch={false}
                                allowClear
                                mode="multiple"
                                className="w-full text-left text-span-select text-sm bg-FCFCFD-ant-select font-regular p-none-select line-none line-none-item inline-none size-selector border-none"
                                popupClassName="position-dropdow custome-select-item h-popUp"
                                variant="borderless"
                                placeholder="Thương hiệu"
                                suffixIcon={null}
                                options={sLCategoryCar}
                                value={dataFilterMatchedCustomers?.listCategoryCar}
                                onChange={(e) => setDataFilterMatchedCustomers({ ...dataFilterMatchedCustomers, listCategoryCar: e })}
                            />
                        </div>
                        <div className="h-full d-flex align-center">
                            <DownOutlined className="text-sm text-98A2B3" />
                        </div>
                    </div>
                </div>
                {/* <div className="custom-page-css h-full flex-2 border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3 justify-between overflow-hidden">
                    <input
                        placeholder="Tìm kiếm thông tin khách hàng"
                        className='custome-select-t w-full border-none h-full custom-page-css'
                        value={dataFilterMatchedCustomers.search}
                        onChange={(e) => setDataFilterMatchedCustomers({ ...dataFilterMatchedCustomers, search: e.target.value })}
                    />
                    <div className="border-l-F2F4F7 h-full d-flex align-center">
                        <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                    </div>
                </div> */}
                <div className='custom-page-css h-36px flex flex-2'>
                    <div className="custom-page-css custom-input-search w-full flex items-center justify-between flex-2 border-F2F4F7 bg-FCFCFD rounded-2  pl-3  overflow-hidden">
                        <input
                            placeholder="Tìm kiếm thông tin khách hàng"
                            className=' border-none  custom-page-css w-full border-none'
                            value={dataFilterMatchedCustomers.search}
                            onChange={(e) => setDataFilterMatchedCustomers({ ...dataFilterMatchedCustomers, search: e.target.value })}
                        />
                        <div className="border-l-F2F4F7 h-full d-flex align-center">
                            <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="custom-page-css w-full flex flex-col   gap-3">
                <div className="custom-page-css flex items- gap-1">
                    <span className='custom-page-css text-base text-344054 font-regular'>{formatPrice(isVoucherCustomerList ? paginationMatchedCustomers.total : selectedIdCustomer.length) } khách hàng</span>
                </div>
            </div>
            <div className="ag-theme-alpine custom-table-ag custom-h-modal" style={{ height: 550, width: '100%' }}>
                <AgGridReact
                    className="my-auto-height-grid"
                    getRowStyle={(params: any) => ({
                        backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                    })}
                    columnDefs={memoizedColumnDefs}
                    loading={loading}
                    loadingOverlayComponent={CustomLoadingOverlayTable}
                    rowData={isVoucherCustomerList
                        ? listMatchedCustomers
                        : listMatchedCustomers.filter(customer =>
                            selectedIdCustomer.map(item => item.customerId).includes(customer.id)
                        )}
                    rowHeight={55}
                    defaultColDef={{
                        resizable: true
                    }}
                    overlayNoRowsTemplate={NodataTable}
                />
            </div>
            <ConfigProvider locale={viVN}>
                <div className="pagination-block">
                    <Pagination
                        showSizeChanger
                        current={paginationMatchedCustomers.current}
                        pageSize={paginationMatchedCustomers.pageSize}
                        total={paginationMatchedCustomers.total}
                        itemRender={(page, type, originalElement) => {
                            // Chỉ custom khi là nút số trang
                            if (type === 'page') {
                                return <span>{formatNumber(page)}</span>;
                            }
                            // prev / next / jump-prev / jump-next giữ nguyên
                            return originalElement;
                        }}
                        showTotal={(total) => `Tổng cộng ${dataPagination(paginationMatchedCustomers.total, paginationMatchedCustomers.pageSize, paginationMatchedCustomers.current).totalPage} trang`}
                        className='rs-pagination'
                        onChange={onPaginationMatchedCustomers}
                    />
                </div>
            </ConfigProvider>
        </div>
    )
}


export default TableCustomerDetail
